import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteGutachtenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteGutachtenCommandService],
  exports: []
})
export class DeleteGutachtenCommandServiceModule { }
